import { render, staticRenderFns } from "./pdNote.vue?vue&type=template&id=278b6b90&scoped=true&"
import script from "./pdNote.vue?vue&type=script&lang=js&"
export * from "./pdNote.vue?vue&type=script&lang=js&"
import style0 from "./pdNote.vue?vue&type=style&index=0&id=278b6b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b6b90",
  null
  
)

export default component.exports